export default "__VITE_ASSET__B40GSxmB__"